import React from 'react';
import { createPortal } from 'react-dom';
import { WalletIcon, XMarkIcon } from '@heroicons/react/24/solid';
import FormBudgetAdd from './FormBudgetAdd';

const ModalBudgetAdd = ({ isOpen, onClose, onSuccess, hierarchicalCategories = {} }) => {
  if (!isOpen) return null;

  const handleCreated = (created) => {
    if (onSuccess) onSuccess(created);
    if (onClose) onClose();
  };

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-sm mx-4 p-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2">
            <WalletIcon className="w-5 h-5 text-green-800" />
            <h2 className="text-base font-semibold text-gray-800">New Budget Entry</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
        <FormBudgetAdd
          hierarchicalCategories={hierarchicalCategories}
          onCreated={handleCreated}
          onCancel={onClose}
        />
      </div>
    </div>,
    document.body
  );
};

export default ModalBudgetAdd;
